import { Box, Stack, Typography } from "@mui/material";
import { RewardsListHeader } from "Components/Loyalty/Shared/Rewards/RewardsList/RewardsListHeader";
import type { RewardEntry } from "Components/Loyalty/Shared/Rewards/types";
import { formatDate } from "Utils/DateUtils";

type Props = {
  items: Array<RewardEntry>;
  pointsLabel: string;
};

export const RewardsList = ({ items, pointsLabel }: Props) => (
  <Stack>
    <RewardsListHeader pointsLabel={pointsLabel} />
    <Box component="ul" p={0} m={0}>
      {items.map(({ date, activity, points }, index) => {
        const isLast = index === items.length - 1;
        const key = `${date.getTime()}-${activity}`;

        return (
          <Box key={key} component="li" sx={{ listStyle: "none" }}>
            <Box
              display="flex"
              py={2}
              alignItems="center"
              borderBottom={isLast ? 0 : 1}
              borderColor="divider"
            >
              <Typography fontSize="0.875rem" flex={1} color="text.secondary">
                {formatDate(date)}
              </Typography>
              <Typography fontSize="0.875rem" flex={2} color="text.secondary">
                {activity}
              </Typography>
              <Typography
                fontSize="0.875rem"
                minWidth={100}
                textAlign="right"
                fontWeight={600}
                color="text.primary"
              >
                +{points}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  </Stack>
);
